import React, { useMemo } from 'react';
import Select, { components } from 'react-select';
import { reactSelectStyles } from '../../../../../helpers/reactSelectStyles';
import styles from './CustomSelect.module.scss';

export const CustomSelectTile = ({ customStyle, customMenu, error, ...rest }) => {
    const menuZIndex = 1000;
    const isWhiteTheme = true;
    const isDarkTheme = false;
    const stylesN = useMemo(
        () => ({
            ...reactSelectStyles,
            control: (styles, { hasValue }) => {
                return {
                    ...reactSelectStyles.control(styles),
                    ...customStyle?.control,
                    backgroundColor: error
                        ? 'var(--error-background-color)'
                        : isDarkTheme
                            ? 'var(--dark-350)'
                            : hasValue || isWhiteTheme
                                ? 'var(--white-color)'
                                : 'var(--neutral20-color)',
                    outline: 'none',
                    boxShadow: 'none',
                    border: error
                        ? '1px solid var(--error-color)'
                        : isDarkTheme
                            ? 'none'
                            : hasValue || isWhiteTheme
                                ? '1px solid var(--neutral20-color)'
                                : 'transparent',
                };
            },
            menuPortal: (styles) => ({
                ...styles,
                zIndex: menuZIndex,
            }),
            menu: (styles, data) => {
                return {
                    ...reactSelectStyles.menu(styles, data),
                    ...customStyle?.menu,
                };
            },
            singleValue: (styles) => ({
                ...styles,
                ...(isDarkTheme && { color: 'var(--white-color)' }),
            }),
            input: (styles) => ({
                ...styles,
                ...(isDarkTheme && { color: 'var(--white-color)' }),
                ...customStyle?.input
            }),
            valueContainer: (styles) => ({
                ...styles,
                ...customStyle?.input
            }),
            dropdownIndicator: (styles, data) => {
                return {
                    ...reactSelectStyles.dropdownIndicator(styles, data),
                    ...customStyle?.dropdownIndicator?.(styles, data),
                };
            },
        }),
        [error]
    );

    const onlySelect = () => {
        return (
            <Select
                {...rest}
                styles={stylesN}
                menuPlacement={'top'}
            />
        )
    }

    const customMenuSelect = () => {
        return (
            <Select
                {...rest}
                styles={stylesN}
                components={{ Menu, Option }}
                menuPlacement={'top'}
            />
        )
    }
    return (customMenu ? customMenuSelect() : onlySelect())
}

const Option = (props) => {
    return (
        <components.Option {...props}>
            <div className={styles.flexContainer}>
                <div>{props.children}</div>
                <div className={styles.colorTab} style={{ backgroundColor: props.data.value }}>

                </div>
            </div> 
        </components.Option>
    );
};

const Menu = (props) => {
    return (
        <components.Menu {...props}>
            <div>
                <div>{props.children}</div>
            </div>
        </components.Menu>
    );
};